module.exports = __webpack_public_path__ + "static/media/bn_final_branding.f033b9c4.png";